import { switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(switchAnatomy.keys);

export const Switch = defineMultiStyleConfig({
	baseStyle: {
		track: {
			_checked: {
				bg: 'primary.bg',
				_hover: {
					bg: 'primary.bgHover',
				},
			},
		},
	},
});
